class WaitHelper {

    setWaitTimeForFunc = (callback: function, ms: number) => {
        return setTimeout(() => {
            callback();
        }, ms)
    }

}

export default new WaitHelper();